/* tslint:disable */
import {
  StockLocation,
  HomogenizationOrder,
  HomogenizationOrderInLine,
  StockWarehouseLocation,
  StockProductionLot,
  Product,
  Company,
  Users,
  FilterValuesQualityAnalysis,
  FilterSizeAnalysis,
  LotQualityAnalysisImage,
  ProductionOrder,
  ProductionOrderOutLine
} from '../index';

declare var Object: any;
export interface LotQualityAnalysisInterface {
  "id"?: number;
  "name"?: string;
  "lot_location_ids"?: any;
  "homogenization_out_line_ids"?: any;
  "homogenization_order_id"?: number;
  "homogenization_in_line_ids"?: any;
  "generated_homogenization_order_ids"?: Array<any>;
  "production_order_out_ids"?: any;
  "warehouse_location_id"?: number;
  "lot_id"?: number;
  "analysis_datetime"?: Date;
  "lot_datetime"?: Date;
  "product_id"?: number;
  "film"?: string;
  "chaff_photo"?: string;
  "image_ids"?: Array<any>;
  "chaff_colour"?: string;
  "other_colour"?: string;
  "defects"?: string;
  "type"?: string;
  "comments"?: string;
  "company_id"?: number;
  "user_id"?: number;
  "state"?: string;
  "density_1"?: number;
  "density_2"?: number;
  "density_3"?: number;
  "density_4"?: number;
  "fluency_1"?: number;
  "fluency_2"?: number;
  "fluency_3"?: number;
  "fluency_4"?: number;
  "volatile_1"?: number;
  "volatile_2"?: number;
  "volatile_3"?: number;
  "volatile_4"?: number;
  "ashes_1"?: number;
  "ashes_2"?: number;
  "ashes_average"?: number;
  "generic_assessment"?: string;
  "ignore_generic_assessment"?: boolean;
  "is_auto_unsuitable"?: boolean;
  "sale_order_id"?: any;
  "sale_order_state"?: string;
  "sale_order_partner_id"?: number;
  "unsuitable_actions"?: string;
  "reclassify_product_id"?: number;
  "avg_carbonate_percentage"?: string;
  "avg_density"?: string;
  "revised_density"?: number;
  "standard_deviation_density"?: number;
  "avg_fluency"?: number;
  "standard_deviation_fluency"?: number;
  "avg_volatile"?: number;
  "standard_deviation_volatile"?: number;
  "filter_1_values"?: Array<any>;
  "filter_2_values"?: Array<any>;
  "filter_size_values"?: Array<any>;
  "distinct_filter_size_value"?: string;
  "production_order_ids"?: any;
  lotLocations?: StockLocation[];
  homogenizationOrder?: HomogenizationOrder;
  homogenizationInLines?: HomogenizationOrderInLine[];
  generatedHomogenizationOrders?: HomogenizationOrder[];
  warehouseLocation?: StockWarehouseLocation;
  lot?: StockProductionLot;
  product?: Product;
  company?: Company;
  user?: Users;
  saleOrderPartner?: Users;
  reclassifyProduct?: Product;
  filter1Values?: FilterValuesQualityAnalysis[];
  filter2Values?: FilterValuesQualityAnalysis[];
  filterSizeValues?: FilterSizeAnalysis[];
  qualityValidProducts?: Product[];
  images?: LotQualityAnalysisImage[];
  productionOrders?: ProductionOrder[];
  productionOrderOuts?: ProductionOrderOutLine[];
}

export class LotQualityAnalysis implements LotQualityAnalysisInterface {
  "id": number;
  "name": string;
  "lot_location_ids": any;
  "homogenization_out_line_ids": any;
  "homogenization_order_id": number;
  "homogenization_in_line_ids": any;
  "generated_homogenization_order_ids": Array<any>;
  "production_order_out_ids": any;
  "warehouse_location_id": number;
  "lot_id": number;
  "analysis_datetime": Date;
  "lot_datetime": Date;
  "product_id": number;
  "film": string;
  "chaff_photo": string;
  "image_ids": Array<any>;
  "chaff_colour": string;
  "other_colour": string;
  "defects": string;
  "type": string;
  "comments": string;
  "company_id": number;
  "user_id": number;
  "state": string;
  "density_1": number;
  "density_2": number;
  "density_3": number;
  "density_4": number;
  "fluency_1": number;
  "fluency_2": number;
  "fluency_3": number;
  "fluency_4": number;
  "volatile_1": number;
  "volatile_2": number;
  "volatile_3": number;
  "volatile_4": number;
  "ashes_1": number;
  "ashes_2": number;
  "ashes_average": number;
  "generic_assessment": string;
  "ignore_generic_assessment": boolean;
  "is_auto_unsuitable": boolean;
  "sale_order_id": any;
  "sale_order_state": string;
  "sale_order_partner_id": number;
  "unsuitable_actions": string;
  "reclassify_product_id": number;
  "avg_carbonate_percentage": string;
  "avg_density": string;
  "revised_density": number;
  "standard_deviation_density": number;
  "avg_fluency": number;
  "standard_deviation_fluency": number;
  "avg_volatile": number;
  "standard_deviation_volatile": number;
  "filter_1_values": Array<any>;
  "filter_2_values": Array<any>;
  "filter_size_values": Array<any>;
  "distinct_filter_size_value": string;
  "production_order_ids": any;
  lotLocations: StockLocation[];
  homogenizationOrder: HomogenizationOrder;
  homogenizationInLines: HomogenizationOrderInLine[];
  generatedHomogenizationOrders: HomogenizationOrder[];
  warehouseLocation: StockWarehouseLocation;
  lot: StockProductionLot;
  product: Product;
  company: Company;
  user: Users;
  saleOrderPartner: Users;
  reclassifyProduct: Product;
  filter1Values: FilterValuesQualityAnalysis[];
  filter2Values: FilterValuesQualityAnalysis[];
  filterSizeValues: FilterSizeAnalysis[];
  qualityValidProducts: Product[];
  images: LotQualityAnalysisImage[];
  productionOrders: ProductionOrder[];
  productionOrderOuts: ProductionOrderOutLine[];
  constructor(data?: LotQualityAnalysisInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LotQualityAnalysis`.
   */
  public static getModelName() {
    return "LotQualityAnalysis";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LotQualityAnalysis for dynamic purposes.
  **/
  public static factory(data: LotQualityAnalysisInterface): LotQualityAnalysis{
    return new LotQualityAnalysis(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LotQualityAnalysis',
      plural: 'LotQualityAnalysiss',
      path: 'LotQualityAnalysiss',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "lot_location_ids": {
          name: 'lot_location_ids',
          type: 'any'
        },
        "homogenization_out_line_ids": {
          name: 'homogenization_out_line_ids',
          type: 'any'
        },
        "homogenization_order_id": {
          name: 'homogenization_order_id',
          type: 'number'
        },
        "homogenization_in_line_ids": {
          name: 'homogenization_in_line_ids',
          type: 'any'
        },
        "generated_homogenization_order_ids": {
          name: 'generated_homogenization_order_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "production_order_out_ids": {
          name: 'production_order_out_ids',
          type: 'any'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
        "lot_id": {
          name: 'lot_id',
          type: 'number'
        },
        "analysis_datetime": {
          name: 'analysis_datetime',
          type: 'Date'
        },
        "lot_datetime": {
          name: 'lot_datetime',
          type: 'Date'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "film": {
          name: 'film',
          type: 'string'
        },
        "chaff_photo": {
          name: 'chaff_photo',
          type: 'string'
        },
        "image_ids": {
          name: 'image_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "chaff_colour": {
          name: 'chaff_colour',
          type: 'string'
        },
        "other_colour": {
          name: 'other_colour',
          type: 'string'
        },
        "defects": {
          name: 'defects',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "comments": {
          name: 'comments',
          type: 'string'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "density_1": {
          name: 'density_1',
          type: 'number'
        },
        "density_2": {
          name: 'density_2',
          type: 'number'
        },
        "density_3": {
          name: 'density_3',
          type: 'number'
        },
        "density_4": {
          name: 'density_4',
          type: 'number'
        },
        "fluency_1": {
          name: 'fluency_1',
          type: 'number'
        },
        "fluency_2": {
          name: 'fluency_2',
          type: 'number'
        },
        "fluency_3": {
          name: 'fluency_3',
          type: 'number'
        },
        "fluency_4": {
          name: 'fluency_4',
          type: 'number'
        },
        "volatile_1": {
          name: 'volatile_1',
          type: 'number'
        },
        "volatile_2": {
          name: 'volatile_2',
          type: 'number'
        },
        "volatile_3": {
          name: 'volatile_3',
          type: 'number'
        },
        "volatile_4": {
          name: 'volatile_4',
          type: 'number'
        },
        "ashes_1": {
          name: 'ashes_1',
          type: 'number'
        },
        "ashes_2": {
          name: 'ashes_2',
          type: 'number'
        },
        "ashes_average": {
          name: 'ashes_average',
          type: 'number'
        },
        "generic_assessment": {
          name: 'generic_assessment',
          type: 'string'
        },
        "ignore_generic_assessment": {
          name: 'ignore_generic_assessment',
          type: 'boolean'
        },
        "is_auto_unsuitable": {
          name: 'is_auto_unsuitable',
          type: 'boolean'
        },
        "sale_order_id": {
          name: 'sale_order_id',
          type: 'any'
        },
        "sale_order_state": {
          name: 'sale_order_state',
          type: 'string'
        },
        "sale_order_partner_id": {
          name: 'sale_order_partner_id',
          type: 'number'
        },
        "unsuitable_actions": {
          name: 'unsuitable_actions',
          type: 'string'
        },
        "reclassify_product_id": {
          name: 'reclassify_product_id',
          type: 'number'
        },
        "avg_carbonate_percentage": {
          name: 'avg_carbonate_percentage',
          type: 'string'
        },
        "avg_density": {
          name: 'avg_density',
          type: 'string'
        },
        "revised_density": {
          name: 'revised_density',
          type: 'number'
        },
        "standard_deviation_density": {
          name: 'standard_deviation_density',
          type: 'number'
        },
        "avg_fluency": {
          name: 'avg_fluency',
          type: 'number'
        },
        "standard_deviation_fluency": {
          name: 'standard_deviation_fluency',
          type: 'number'
        },
        "avg_volatile": {
          name: 'avg_volatile',
          type: 'number'
        },
        "standard_deviation_volatile": {
          name: 'standard_deviation_volatile',
          type: 'number'
        },
        "filter_1_values": {
          name: 'filter_1_values',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "filter_2_values": {
          name: 'filter_2_values',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "filter_size_values": {
          name: 'filter_size_values',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "distinct_filter_size_value": {
          name: 'distinct_filter_size_value',
          type: 'string'
        },
        "production_order_ids": {
          name: 'production_order_ids',
          type: 'any'
        },
      },
      relations: {
        lotLocations: {
          name: 'lotLocations',
          type: 'StockLocation[]',
          model: 'StockLocation',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'lot_location_ids'
        },
        homogenizationOrder: {
          name: 'homogenizationOrder',
          type: 'HomogenizationOrder',
          model: 'HomogenizationOrder',
          relationType: 'belongsTo',
                  keyFrom: 'homogenization_order_id',
          keyTo: 'id'
        },
        homogenizationInLines: {
          name: 'homogenizationInLines',
          type: 'HomogenizationOrderInLine[]',
          model: 'HomogenizationOrderInLine',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'homogenization_in_line_ids'
        },
        generatedHomogenizationOrders: {
          name: 'generatedHomogenizationOrders',
          type: 'HomogenizationOrder[]',
          model: 'HomogenizationOrder',
          relationType: 'referencesMany',
                  keyFrom: 'generated_homogenization_order_ids',
          keyTo: 'id'
        },
        warehouseLocation: {
          name: 'warehouseLocation',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        lot: {
          name: 'lot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'lot_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        user: {
          name: 'user',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'user_id',
          keyTo: 'id'
        },
        saleOrderPartner: {
          name: 'saleOrderPartner',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'sale_order_partner_id',
          keyTo: 'id'
        },
        reclassifyProduct: {
          name: 'reclassifyProduct',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'reclassify_product_id',
          keyTo: 'id'
        },
        filter1Values: {
          name: 'filter1Values',
          type: 'FilterValuesQualityAnalysis[]',
          model: 'FilterValuesQualityAnalysis',
          relationType: 'referencesMany',
                  keyFrom: 'filter_1_values',
          keyTo: 'id'
        },
        filter2Values: {
          name: 'filter2Values',
          type: 'FilterValuesQualityAnalysis[]',
          model: 'FilterValuesQualityAnalysis',
          relationType: 'referencesMany',
                  keyFrom: 'filter_2_values',
          keyTo: 'id'
        },
        filterSizeValues: {
          name: 'filterSizeValues',
          type: 'FilterSizeAnalysis[]',
          model: 'FilterSizeAnalysis',
          relationType: 'referencesMany',
                  keyFrom: 'filter_size_values',
          keyTo: 'id'
        },
        qualityValidProducts: {
          name: 'qualityValidProducts',
          type: 'Product[]',
          model: 'Product',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'quality_valid_products_ids'
        },
        images: {
          name: 'images',
          type: 'LotQualityAnalysisImage[]',
          model: 'LotQualityAnalysisImage',
          relationType: 'referencesMany',
                  keyFrom: 'image_ids',
          keyTo: 'id'
        },
        productionOrders: {
          name: 'productionOrders',
          type: 'ProductionOrder[]',
          model: 'ProductionOrder',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'production_order_ids'
        },
        productionOrderOuts: {
          name: 'productionOrderOuts',
          type: 'ProductionOrderOutLine[]',
          model: 'ProductionOrderOutLine',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'production_order_out_ids'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LotQualityAnalysis.ts